import request from './request';
import { useSystemInfo } from '@/store';
  
// 查询首页banner配置
export const getHomeConfigs = () => {
  const language = useSystemInfo().language
  return request({
    url: '/carbon-misc/public/web/config/home/banner',
    method: 'GET',
    params: {
      language
    }
  }, {
    skipTime: 15000
  });
}
  